'use strict'

import APIList from "./apiList";

const Pagination = {
    el: null,
    currentPage: 1,
    init: function () {
        Pagination.el = document.querySelector('.c-pagination');
        if (Pagination.el) {
            const prev = Pagination.el.querySelector('.prev');
            if (prev) {
                prev.addEventListener('click', (e) => {
                    e.preventDefault();
                    Pagination.updateUrl(Pagination.currentPage - 1);
                });
            }

            const next = Pagination.el.querySelector('.next');
            if (next) {
                next.addEventListener('click', (e) => {
                    e.preventDefault();
                    Pagination.updateUrl(parseInt(Pagination.currentPage) + 1);
                });
            }

            const items = Pagination.el.querySelectorAll(".page-numbers:not(.prev):not(.next):not(.current)");
            if (items && items.length > 0) {
                items.forEach(link => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                        Pagination.updateUrl(link.innerText);
                    });
                });
            }
        }
    },
    updateUrl: function (newPage) {
        let url = new URL(window.location);
        url.searchParams.set('paged', newPage);
        url.search = decodeURIComponent(url.search);
        window.history.pushState({}, '', url);

        Pagination.currentPage = parseInt(newPage);

        APIList.getDatas();
    }
}

export default Pagination;